interface CharCounterProps {
  current: number;
  min?: number | null;
  max?: number | null;
}

export default function CharCounter({ current, min, max }: CharCounterProps) {
  const belowMin = min != null && current < min;
  const aboveMax = max != null && current > max;
  const color = aboveMax ? '#c0392b' : belowMin ? '#b07d00' : 'var(--muted-foreground)';
  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ fontSize: 12, color, textAlign: 'right' }}>
        {current.toLocaleString('hu-HU')} karakter
        {min != null && <span> · min {min.toLocaleString('hu-HU')}</span>}
        {max != null && <span> · max {max.toLocaleString('hu-HU')}</span>}
      </div>
      {/* Explicit error message so the constraint is unmistakable, not just a colour change */}
      {belowMin && (
        <div style={{ fontSize: 12, color: '#b07d00', textAlign: 'right', marginTop: 2 }}>
          Még {(min! - current).toLocaleString('hu-HU')} karakter szükséges a minimumhoz.
        </div>
      )}
      {aboveMax && (
        <div style={{ fontSize: 12, color: '#c0392b', textAlign: 'right', marginTop: 2 }}>
          {(current - max!).toLocaleString('hu-HU')} karakterrel lépted túl a maximumot.
        </div>
      )}
    </div>
  );
}
